import { useRoutes } from 'react-router-dom'
import { routes } from 'src/router'
import { HeaderBtnType, HeaderImgType } from 'src/components/layout/Header'

export interface IsHeaderMetaDataType {
  leftImg?: HeaderImgType
  text?: string
  rightImg?: HeaderImgType
  rightBtn?: HeaderBtnType
}

interface metaDataType {
  isHeader?: IsHeaderMetaDataType
  isFooter?: boolean
  isTopButton?: string
}

const useRouteToMetaData = (): metaDataType => {
  const couponwallet_routes = useRoutes(routes)

  return (
    couponwallet_routes?.props?.match?.route?.meta ?? {
      isFooter: undefined,
      isHeader: undefined,
      isTopButton: undefined,
    }
  )
}
export default useRouteToMetaData
